import { useTranslation } from 'react-i18next'
import './header.scoped.scss'

const Header = ({ loadingSubmit, onOpenEvent }) => {
  const [t] = useTranslation('overlayContentVideo')
  return (
    <div className="header">
      <i
        className="fa-regular fa-arrow-left-long"
        style={{ color: 'var(--white)', fontSize: '18px', cursor: !loadingSubmit ? 'pointer' : 'not-allowed' }}
        onClick={() => (!loadingSubmit ? onOpenEvent(false) : null)}
        role="button"
        tabIndex={0}
      ></i>
      <h5 className="ml-3">{t('title')}</h5>
    </div>
  )
}

export default Header
